
// import React from 'react'
// // import CustomTable from '../../../Components/Table/CustomTable';

// import { Grid } from '@mui/material';
// import CustomTable from '../../../../Components/Table/CustomTable';
// import RegistrationDetailsModal from '../Modal/RegistrationDetailsModal';

// // import UserRoleCreateModal from '../Modal/UserRoleCreateModal';

// const RegistrationReject = () => {


//     const tableData = [
//         { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Financial Consultant", Status: "Reject" },
//         { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Financial Consultant", Status: "Reject" },
//         { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Financial Consultant", Status: "Reject" },
//         { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Financial Consultant", Status: "Reject" },
//         { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Reject" },



//     ];
//     const tableHeadData = ['S.No', 'Name', "Email", "Mobile Number", "User Type", 'Status'];
//     return (
//         <Grid container spacing={2}>

//             <Grid item xs={12} sx={{ width: "100px" }}>
//                 <CustomTable
//                     tableData={tableData}
//                     tableView="tableView"

//                     title="Registration Approval"
//                     tableHeadData={tableHeadData}
//                     dataCreate="dataCreate"
//                     modalHeadingName="Create User Role"
//                     modalVeiwName={RegistrationDetailsModal}
//                     ModalViewComponent1="ModalViewComponent"
//                     modalViewHeadingName="User Detail"
//                     // modalHeadingName="Registration Details"
//                 />

//             </Grid>
//         </Grid>
//     )
// }

// export default RegistrationReject


import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";
import RegistrationDetailsModal from "../Modal/RegistrationDetailsModal";
import actions from "../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../../ReduxStore/Slices/headerSlice";

const RegistrationReject = () => {
    const tableData = [
        {
            Name: "Vallarasu",
            Email: "valla@gmail.com",
            MobileNumber: "1232343444",
            UserType: "Financial Consultant",
            Status: "Pending",
        },
        {
            Name: "Pravin",
            Email: "pravin@gmail.com",
            MobileNumber: "98787687687",
            UserType: "Financial Consultant",
            Status: "Pending",
        },
        {
            Name: "Shahul",
            Email: "shahul@gmail.com",
            MobileNumber: "123322443543",
            UserType: "Financial Consultant",
            Status: "Pending",
        },
        {
            Name: "Ramesh",
            Email: "Ramesh@gmail.com",
            MobileNumber: "76575675664",
            UserType: "Financial Consultant",
            Status: "Pending",
        },
        {
            Name: "Sanjeev",
            Email: "Sanjeev@gmail.com",
            MobileNumber: "909878789709",
            UserType: "Financial Consultant",
            Status: "Pending",
        },
    ];
    const tableHeadData = [
        "S.No",
        "Name",
        "Email",
        "Mobile Number",
        "User Type",
        "Creator Role",
        "Creator Name",
        "Rejector Name",  
        "Status",
    ];

    const dispatch = useDispatch()
    const { getAllRejectedCustomersWithCreatorAndRejector } = useSelector(
        (state) => state?.getAllRejectedCustomersWithCreatorAndRejector
    );

    console.log(
        getAllRejectedCustomersWithCreatorAndRejector?.data,
        "getAllRejectedCustomersWithCreatorAndRejector"
    );

    const { approveCustomer } = useSelector((state) => state?.approveCustomer);

    const { managementRegisterForCustomer } = useSelector(
        (state) => state?.managementRegisterForCustomer
    );
    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getAllRejectedCustomersWithCreatorAndRejector`,
            };
            await dispatch(actions.GETALLREJECTEDCUSTOMERSWITHCREATORANDREJECTOR(data1));
        };
        fetchData();
    }, [dispatch, approveCustomer]);

    const [rowTableData, setRowTableData] = useState([
        {
            Name: "--",
            customer_id: "--",
            email: "--",
            phone: "--",
            role: "--",
            approval_status: "--",
        },
    ]);
    console.log(rowTableData, "rowTableDatarowTableData")

    useEffect(() => {
        const tempArr = [];
        console.log(getAllRejectedCustomersWithCreatorAndRejector, 'getAllRejectedCustomersWithCreatorAndRejectorgetAllRejectedCustomersWithCreatorAndRejector')

        getAllRejectedCustomersWithCreatorAndRejector?.data?.map((data, index) => {
            return tempArr.push({
                Name: `${data?.first_name} ${data?.last_name}`,
                customer_id: data?.customer_id,
                email: data?.email,
                phone: data?.phone,
                role: data?.role === "customer" ? "Individual" : data?.role,
                creatorName: data?.creator === null ? "Self" : data?.creator?.name,
                creatorRole: data?.creatorRole === null ? "Self" : data?.creatorRole?.roleName,
                rejectorName: data?.rejector?.name,
                
                approval_status:
                    `${data?.approval_status?.charAt(0).toUpperCase() +
                    data?.approval_status?.slice(1)} by ${data?.rejectorRole?.roleName}`,
            });
        });
        setRowTableData(tempArr);
    }, [getAllRejectedCustomersWithCreatorAndRejector]);

    React.useEffect(() => {
        dispatch(setHeaderName("Registration Approval"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableData={rowTableData}
                    title="Registration Approval"
                    tableView="tableView"
                    tableHeadData={tableHeadData}
                    showRejectCommand={true}
                    modalVeiwName={RegistrationDetailsModal}
                    ModalViewComponent1="ModalViewComponent"
                    modalViewHeadingName="User Detail"
                    modalHeadingName="Registration Details"
                />
            </Grid>
        </Grid>
    );
};

export default RegistrationReject;
